<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-popup class="holamundo" title="Çekiliş Sil" :active.sync="deletePopupActive" v-esc="escape">
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Çekilişi Silmek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
                   @click="removeDraw(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <new-draw ref="newDraw" @success="reloadData"/>
    <vs-row vs-type="flex" vs-w="12" id="campaignPageHeader">
      <vx-tooltip v-if="$isCenterBranch() && isNewDrawPermission" text="Yeni Çekiliş" position="top">
        <vs-button @click="openNewDrawPage" class="panel-action text-success xlarge-button panel-action-box-shadow"
                   color="transparent" icon-pack="feather" icon="icon-plus">
        </vs-button>
      </vx-tooltip>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="drawPageContent">
      <vs-row vs-type="flex" vs-w="12" id="drawList">
        <vs-col vs-type="flex"  class="campaingItem" v-for="draw in draws" :key="draw.id">
          <vs-row vs-type="block" vs-w="12">
            <vs-row class="drawTitle py-1" vs-type="flex" vs-w="12">
              <vx-tooltip :text="draw.title" color="primary" position="top" class="w-full flex">
              <span class="text-small text-primary bold">
                {{ draw.title }}
              </span>
              </vx-tooltip>
            </vs-row>
            <vs-row class="border-all" vs-type="flex" vs-w="12" style="background-color:#00000070;position: relative;">
              <div class="drawImgDiv m-auto">
                <img :src="$baseUrl + '/' + draw.image" alt="img" class="responsive">
              </div>
              <span class="text-smaller py-1 px-2 drawDescription text-white weight-600">
                {{ draw.description }}
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-1">
                <span class="text-smaller text-dark weight-600 mr-auto">
                  {{ formatDate(draw.startDate) }}
                </span>
              <span class="text-smaller text-dark weight-600 ml-auto">
                  {{ formatDate(draw.endDate) }}
                </span>
              <vx-tooltip :text="draw.leftTime" color="primary" position="top" class="w-full">
                <vs-progress :height="8" :percent="draw.toFinish"
                             :color="draw.toFinish == 100 ? 'danger' : 'success'">
                </vs-progress>
              </vx-tooltip>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="py-2">
              <vx-tooltip
                :text="draw.isPublished ? ($isCenterBranch() ? 'Yayından Kaldır !' : 'Yayında') : ($isCenterBranch() ? 'Yayınla !' : 'Yayında Değil')"
                color="primary"
                position="top">
                <vs-button :disabled="!$isCenterBranch()" @click="PublishDraw(draw.id)" class="ml-1"
                           icon-pack="feather"
                           icon="icon-monitor" :color="draw.isPublished ? 'success' : 'danger'"/>
              </vx-tooltip>
              <vx-tooltip
                text="Çekilişi Kopyala"
                color="primary"
                position="top">
                <vs-button :disabled="!$isCenterBranch()" @click="CloneDraw(draw.id)" class="ml-1"
                           icon-pack="feather"
                           icon="icon-copy" color="warning"/>
              </vx-tooltip>
              <vx-tooltip v-show="$isCenterBranch() && isNewDrawPermission" class="ml-auto" text="Sil" color="primary" position="top">
                <vs-button :disabled="draw.isPublished"
                           @click="deletePopupActive = true;deletedId = draw.id;"
                           icon-pack="feather" icon="icon-trash" color="danger"/>
              </vx-tooltip>
              <vx-tooltip class="ml-1" text="Ayarlar" color="primary" position="top">
                <vs-button @click="editDraw(draw)" icon-pack="feather"
                           icon="icon-settings" color="primary"/>
              </vx-tooltip>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-row>
</template>

<script>
import NewDraw from "./NewDraw";
import {
  GetDraws,
  PublishDraw,
  CloneDraw,
  DeleteDraw
} from "@/api/Draw";
import {isGranted} from "@/utils/auth";
export default {
  data() {
    return {
      draws: [],
      tableOptions: {},
      deletePopupActive: false,
      deletedId: null
    }
  },
  components: {
    NewDraw
  },
  computed:{
    isNewDrawPermission(){
      return isGranted("draw_write")
    }
  },
  methods: {
    escape() {
      if (this.deletePopupActive) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    removeDraw(drawId) {
      DeleteDraw(drawId).then(res => {
        if (res && res.data.isSuccess) {
          this.deletePopupActive = false;
          this.deletedId = null;
          this.reloadData()
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı !',
            text: res.data.message
          });
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: res.data.message
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });
    },
    CloneDraw(drawId) {
      CloneDraw(drawId).then(res => {
        if (res && res.data.isSuccess) {
          this.reloadData();
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı !',
            text: res.data.message
          });
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: res.data.message
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      })
    },
    PublishDraw(drawId) {
      PublishDraw(drawId).then(res => {
        if (res && res.data.isSuccess) {
          this.reloadData();
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı !',
            text: res.data.message
          });
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: res.data.message
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });
    },
    editDraw(draw) {
      this.$refs.newDraw.draw = {
        title: draw.title,
        description: draw.description,
        titleEn: draw.titleEn,
        descriptionEn: draw.descriptionEn,
        dateRange: {
          startDate: new Date(draw.startDate),
          endDate: new Date(draw.endDate)
        },
        drawDate: new Date(draw.drawDate),
        image: draw.image,
        prefix: draw.prefix,
        isPublished: draw.isPublished,
        entityType: draw.entityType,
        entityIds: draw.entityIds,
        amount: draw.amount,
        amountType: draw.amountType,
        id: draw.id
      };
      this.$refs.newDraw.fillRestOptions();
      this.$refs.newDraw.selectedRestOptions = _.cloneDeep(draw.restOptions);
      this.$refs.newDraw.needUpload = false;
      this.openNewDrawPage()
    },
    formatDate(formatDate) {
      let dateTime = formatDate.split("T");
      return dateTime[0];
    },
    openNewDrawPage() {
      this.$refs.newDraw.isActive = true;
    },
    reloadData() {
      this.GetDraws();
    },
    GetDraws() {
      GetDraws(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          this.draws = res.data;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Çekilişler Yüklenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.GetDraws();
      }
    }
  },
  created() {
    this.tableOptions = {
      drawId: null,
      title: null,
      description: null,
      startDate: null,
      endDate: null,
      isPublished: null
    };
  }
}
</script>
<style>

.drawImgDiv {
  filter: brightness(55%);
  height: 22.5vh;
  overflow: hidden;
  min-height: 150px;
  position: relative;
  width: 100%;
}

.drawDescription {
  position: absolute;
  height: 22.5vh;
  overflow: hidden;
  text-shadow: 1px 1px rgba(var(--vs-primary), 1);
}

.drawTitle {
  border-radius: 8px;
}

.drawTitle span {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

</style>
